import { Handler, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { AutocompleteApiParameter, autocompleteSearch } from "@insite/client-framework/Services/AutocompleteService";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/CommonHandlers/GetAutocompleteModel";
import { AutocompleteModel } from "@insite/client-framework/Types/ApiModels";

type Parameter = AutocompleteApiParameter & HasOnSuccess<AutocompleteModel>;
type Props = {
    apiParameter: AutocompleteApiParameter;
    apiResult: AutocompleteModel;
};

type HandlerType = Handler<Parameter, Props>;

export const RequestDataFromApiCustom: HandlerType = async props => {
    if (props.apiParameter.searchOnTyping || props.apiParameter.query.length >= 3) {
        props.apiResult = await autocompleteSearch(props.apiParameter);
    } else {
        props.apiResult = undefined as any;
    }
};
replaceInChain(chain, RequestDataFromApi, RequestDataFromApiCustom);
